import React, { useState, useEffect } from "react";
import {
    Create,
    SimpleForm,
    TextInput,
    useNotify,
    useRedirect,
    useRefresh,
    SelectInput,
    DateInput,
    required,
    AutocompleteInput
} from 'react-admin';
import {get} from 'lodash';

import GennevApiService from '../../services/gennev-api.service';

export const UserCreate = (props) => {
    const [states, setStates] = useState([]);
    const [password, setPassword] = useState(() => '');
    const [showPassword, setShowPassword] = useState(() => false);
    const [cities, setCities] = useState([]);
    const [selectedStateId, setSelectedStateId] = useState(null);
    const notify = useNotify();
    const refresh = useRefresh();
    const redirect = useRedirect();

    const onError = error => { // Show the server error message if it exists
        notify(get(error, 'body.errors.message',  'Error creating the user'), { type: 'error'});
    };

    const onSuccess = () => {
        redirect('/admin/user');
        notify('User was created successfully');
        refresh();
    };

    useEffect(() => {
        GennevApiService.getStates().then(({data}) => setStates(data));
    }, []);

    useEffect(() => {
        if(!selectedStateId) return; // set by default to null
        GennevApiService.getCities(selectedStateId).then(({cities}) => setCities(cities));
    }, [selectedStateId]);

    return (
        <Create {...props} mutationOptions={{ onSuccess, onError }} >
            <SimpleForm>
                <TextInput source="first_name" validate={[required()]} />
                <TextInput source="last_name" validate={[required()]} />
                <TextInput source="email" validate={[required()]}/>
                <TextInput
                    id="password"
                    source="password"
                    validate={[required()]}
                    type={showPassword ? 'text': 'password' }
                    value={password}
                    onFocus={() => setShowPassword(true)}
                    onBlur={() => setShowPassword(false)}
                    onChange={e => setPassword(e.target.value)}
                />
                <TextInput source="nickname" />
                <TextInput source="about_me" multiline />
                <DateInput source="birthdate" />
                <SelectInput
                    source="state_id"
                    choices={states.map(({id, name}) => ({id, name}))}
                    onChange={e => setSelectedStateId(
                        states.find(({id}) => e.target.value === id).id
                    )}
                />
                <AutocompleteInput
                    source="city_id"
                    choices={cities.map(({id, name}) => ({id, name}))}
                    disabled={!cities.length}
                />
                <SelectInput source="gender" choices={[
                    {id: 'male', name: 'Male'},
                    {id: 'female', name: 'Female'}
                ]}/>
                <TextInput source="phone_number" autocomoplete="off"/>
            </SimpleForm>
        </Create>
    )
};
